import { h } from "hyperapp";

import { Users } from "../../common/users/main";

export const controls = ({ actions, section, state }): JSX.Element => {
  return (
    <form
      key="schedulingControls"
      onsubmit={event => (
        event.preventDefault(), actions.sendProtoTasks({ section })
      )}
    >
      <div class="align-items-end justify-content-end form-row">
        <div class="col-sm-auto mb-3">
          <label for="to">Data</label>
          <input
            class="form-control"
            disabled={state.scheduling.sending || state.scheduling.done}
            id="to"
            min={new Date(Date.now()).toISOString().substring(0, 10)}
            onblur={event =>
              actions.setProtoTasksDate({ date: event.target.value })
            }
            required
            type="date"
            value={state.scheduling.date}
          />
        </div>
        {Users({
          actions,
          disabled: state.scheduling.sending || state.scheduling.done,
          loading: state.loadingUsers,
          section,
          state,
        })}
        <div class="col-sm-auto mb-3">
          <button
            class="btn btn-outline-primary form-control"
            disabled={
              state.loadingUsers ||
              state.scheduling.sending ||
              state.scheduling.done
            }
            type="submit"
          >
            Agendar
          </button>
        </div>
      </div>
    </form>
  );
};
